<template>
  <div
    class="slide-imgs-container"
    :style="{
      'margin-top': cc.margin_top + 'px' || gc.margin_top + 'px',
      'margin-bottom': cc.margin_bot + 'px' || gc.margin_bot + 'px',
      padding: cc.padding ? cc.padding + 'px 0' : '0',
      background: cc.mod_bg_img ? `url(${cc.mod_bg_img})` : '',
      'background-size': 'cover',
    }"
  >
    <div
      class="swiper-container"
      :style="{
        'padding-left': cc.bg_space_left + 'px',
        'padding-top': padding_t_b[0] + 'px',
        'padding-bottom': padding_t_b[1] + 'px',
      }"
    >
      <div
        class="bg-container"
        :style="{
          position: 'absolute',
          top: 0,
          left: 0,
          width: `${cc.bg_width}px`,
          height: `${cc.bg_height}px`,
          background: `${
            cc.bg_type == 'color' ? cc.bg_color : 'url(' + cc.bg_img + ')'
          } no-repeat`,
          'background-size': '100% 100%',
        }"
      ></div>
      <div
        class="swiper main-swiper"
        :style="{
          position: 'relative',
        }"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="item in list"
            :key="item.img"
            :style="{
              'box-sizing': 'content-box',
              width: cc.width_scale_screen + 'vw',
              'padding-right': cc.space + 'px',
            }"
            @click.stop="jump(item)"
          >
            <img
              :src="item.img"
              alt=""
              :style="{
                'object-fit': 'cover',
              }"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { utils } from '_lib/utils'
import { ComponentCommonMixin } from '../mixin'
import { clickImage } from '_api/activity-common-template'
import { eventBus } from '_lib/event-bus'
import Swiper from 'swiper'
import 'swiper/swiper.min.css'

export default {
  mixins: [ComponentCommonMixin],
  computed: {
    padding_t_b() {
      return this.cc.bg_space_top_bot
        .replace(/\s+/g, '')
        .replace(/，/g, ',')
        .split(',')
    },
  },
  data() {
    return {
      swiper: {},
      list: [],
    }
  },
  created() {
    this.list = this.cd['slide-imgs'].sort((a, b) => {
      ;+a.img_pos - +b.img_pos
    })
    setTimeout(() => {
      this.swiper = new Swiper('.main-swiper', {
        allowTouchMove: true,
        slidesPerView: 'auto', // 根据内容宽度自动设置数量
        loop: false, // 循环模式选项
        // freeMode: true,
        // spaceBetween: this.cc.space,
      })
    }, 100)
  },
  methods: {
    jump(img) {
      if (!img.img_prot) {
        return
      }
      if (!this.is_in_heybox) {
        this.openInHeybox()
        return
      }
      img.img_prot
      if (['protocol', 'path', 'url'].includes(img.img_type)) {
        this.reportData()
      }
      if (img.img_type == 'url') {
        // 跳转链接
        utils.executeProtocol({
          protocol_type: 'openWindow',
          webview: {
            url: img.img_prot,
          },
        })
      } else if (img.img_type == 'href') {
        // 直接打开外链
        window.location.href = img.img_prot
      } else if (img.img_type == 'protocol') {
        // 执行协议
        utils.executeProtocol(img.img_prot)
      } else if (img.img_type == 'href') {
        clickImage(img.img_prot, {
          act_id: this.act_id || this.querys.act_id,
          heybox_id: this.querys.heybox_id,
          task_os_type: this.querys.task_os_type,
          client_version: this.querys.version,
        })
          .then((res) => {
            if (res.data.status == 'ok') {
              const result = res.data.result
              if (result.count_num) {
                eventBus.$emit('changeVal', 'count_num', result.count_num)
                utils.showMessage('ok', '预约成功！')
              } else if (result.front_task_error) {
                this.front_task_jump_protocol = result.jump_protocol
                this.modal_msg = '前置任务'
                this.modal_desc = result.error_msg
                this.confirm_btn_text = '去完成'
                this.showModal()
              }
            } else {
              utils.showMessage('failed', res.data.msg)
            }
          })
          .catch(() => {
            utils.showMessage('failed', '网络错误！')
          })
      }
    },
  },
}
</script>

<style lang="less" scoped>
.swiper-container {
  position: relative;
}
.swiper-slide {
  img {
    width: 100%;
  }
}
</style>
